import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CompanyVerificationEffects } from './store/company-verification.effects';
import {
  CompanyVerificationNamespace,
  CompanyVerificationReducer,
} from './store/company-verification.store';

export const companyVerificationStateProvider = provideState(
  CompanyVerificationNamespace,
  CompanyVerificationReducer,
);

export const companyVerificationEffectsProvider = provideEffects([CompanyVerificationEffects]);

export const companyVerificationData = [
  companyVerificationEffectsProvider,
  companyVerificationStateProvider,
];
